/**
 * math.js — Utility math helpers with strong DX
 * -------------------------------------------
 * Minimal, predictable, extensible.
 * All functions are pure and side-effect free.
 */

/**
 * Linear interpolation.
 * @param {number} a - Start value
 * @param {number} b - End value
 * @param {number} t - Interpolation factor 0 → 1
 */
export const lerp = (a, b, t) => a + (b - a) * t;

/**
 * Clamp a value between a minimum and maximum.
 * @param {number} v - Value to clamp
 * @param {number} min - Lower bound
 * @param {number} max - Upper bound
 */
export const clamp = (v, min = 0, max = 1) => Math.min(Math.max(v, min), max);

/**
 * Clamp a value between 0 and 1.
 * @param {number} v - Value to clamp
 */
export const clamp01 = v => Math.max(0, Math.min(1, v));